import { defaultAd300x250, IAdUnit } from "../unit";

export enum DesktopContentPageScrollEnum {
  DesktopContentPageScroll1 = "Desktop Content Page Scroll 1",
  DesktopContentPageScroll2 = "Desktop Content Page Scroll 2",
  DesktopContentPageScroll3 = "Desktop Content Page Scroll 3",
  DesktopContentPageScroll4 = "Desktop Content Page Scroll 4",
  DesktopContentPageScroll5 = "Desktop Content Page Scroll 5",
  DesktopContentPageScroll6 = "Desktop Content Page Scroll 6",
  DesktopContentPageScroll7 = "Desktop Content Page Scroll 7",
  DesktopContentPageScroll8 = "Desktop Content Page Scroll 8",
  DesktopContentPageScroll9 = "Desktop Content Page Scroll 9",
  DesktopContentPageScroll10 = "Desktop Content Page Scroll 10",
}

export const DesktopContentPageScrollUnits: { [name in DesktopContentPageScrollEnum]: IAdUnit } = {
  [DesktopContentPageScrollEnum.DesktopContentPageScroll1]: {
    ...defaultAd300x250,
    sid: "1232699",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll2]: {
    ...defaultAd300x250,
    sid: "1232701",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll3]: {
    ...defaultAd300x250,
    sid: "1232702",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll4]: {
    ...defaultAd300x250,
    sid: "1232703",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll5]: {
    ...defaultAd300x250,
    sid: "1232704",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll6]: {
    ...defaultAd300x250,
    sid: "1232705",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll7]: {
    ...defaultAd300x250,
    sid: "1232706",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll8]: {
    ...defaultAd300x250,
    sid: "1232707",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll9]: {
    ...defaultAd300x250,
    sid: "1232708",
  },
  [DesktopContentPageScrollEnum.DesktopContentPageScroll10]: {
    ...defaultAd300x250,
    sid: "1232709",
  },
};
